import _Set from "@babel/runtime-corejs2/core-js/set";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { Container } from 'react-bootstrap';
import { Col, Row, Button, Icon } from '@mch-group/uikit-components';
import { Autocomplete, Artist } from '@dmi-mch/services';
import { buildSelectedWithConvertOptions, validateAxiosResponse as ValidateAxiosResponse, logger as Logger, useDebounce } from '@dmi-mch/utils';
import { InputFeedback, Input } from '@dmi-mch/components';
import CMultiSelect from './common/CMultiSelect';
import ModalStyled from './common/ModalStyled';

var ArtistForm = function ArtistForm(props) {
  var handleSubmit = props.handleSubmit,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      errors = props.errors,
      touched = props.touched,
      values = props.values,
      _props$bindSubmitForm = props.bindSubmitForm,
      bindSubmitForm = _props$bindSubmitForm === void 0 ? function () {} : _props$bindSubmitForm,
      submitForm = props.submitForm,
      defaultFirstName = props.defaultFirstName,
      setFieldValue = props.setFieldValue,
      status = props.status,
      labels = props.labels;
  bindSubmitForm(submitForm); // adding the value in the form, introduced by the user when searching an artist and not finding it.
  // It splits trying to separate name and surname

  useEffect(function () {
    var splitName = "".concat(defaultFirstName).split(' ');
    setFieldValue('firstName', splitName[0]);

    if (splitName[1]) {
      setFieldValue('lastName', splitName[1]);
    }
  }, [defaultFirstName, setFieldValue]);
  return /*#__PURE__*/React.createElement("form", {
    autoComplete: "off",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    columns: 2
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "firstName"
  }, /*#__PURE__*/React.createElement("b", null, labels.labelsForm.translate('artistNameLabel'))), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "firstName",
    id: "firstName",
    error: errors.firstName && touched.firstName,
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.firstName
  }), errors.firstName && touched.firstName && /*#__PURE__*/React.createElement(InputFeedback, null, errors.firstName))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "lastName"
  }, /*#__PURE__*/React.createElement("b", null, labels.labelsForm.translate('artistSurnameLabel'))), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "lastName",
    id: "lastName",
    error: errors.lastName && touched.lastName,
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.lastName
  }), errors.lastName && touched.lastName && /*#__PURE__*/React.createElement(InputFeedback, null, errors.lastName)))), status && /*#__PURE__*/React.createElement(InputFeedback, null, status)));
};

ArtistForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
  bindSubmitForm: PropTypes.func,
  submitForm: PropTypes.func,
  defaultFirstName: PropTypes.string,
  setFieldValue: PropTypes.func,
  status: PropTypes.string,
  labels: PropTypes.object
};
var FormRules = withFormik({
  mapPropsToValues: function mapPropsToValues() {
    var formValues = {
      firstName: '',
      lastName: ''
    };
    return formValues;
  },
  validationSchema: function validationSchema(props) {
    var schema = {
      firstName: Yup.string().max(255).required(props.labels.labelsValidation.translate('RequiredFieldMessage')),
      lastName: Yup.string().max(255).required(props.labels.labelsValidation.translate('RequiredFieldMessage'))
    };
    return Yup.object().shape(schema);
  },
  handleSubmit: function () {
    var _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, _ref) {
      var resetForm, props, setStatus, artistService, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resetForm = _ref.resetForm, props = _ref.props, setStatus = _ref.setStatus;
              // resetting any other message that could be on screen
              setStatus(null); // Starting the process of creating new artist

              artistService = new Artist(props.context);
              _context.prev = 3;
              _context.next = 6;
              return artistService.post({
                firstName: values.firstName.trim(),
                lastName: values.lastName.trim()
              });

            case 6:
              response = _context.sent;

              if (ValidateAxiosResponse(response)) {
                // Calling callback that adds the new artist in the box.
                // Receives the item in "dropdown" format, ready to digest
                props.forceNewSelectedArtist({
                  key: response.data.id,
                  value: response.data.id,
                  text: response.data.name,
                  name: response.data.name
                });
                props.setNewArtistModalOpen(false);
                resetForm(values);
              } else if (response.status === 409) {
                setStatus(response.data.message);
              } else {
                // This is here for future cases of IF
                setStatus(response.data.message);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              Logger(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    function handleSubmit(_x, _x2) {
      return _handleSubmit.apply(this, arguments);
    }

    return handleSubmit;
  }(),
  displayName: 'ArtistSelector'
})(ArtistForm);

var ArtistSelector = function ArtistSelector(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      newArtistModalOpen = _useState2[0],
      setNewArtistModalOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      userInputValue = _useState4[0],
      setUserInputValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var debouncedSearchTerm = useDebounce(userInputValue, 500);
  var searchTerm = useRef(null); // eslint-disable-next-line no-unused-vars

  var name = props.name,
      labels = props.labels,
      context = props.context,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {} : _props$setFieldValue,
      fieldName = props.fieldName,
      defaultValue = props.defaultValue;
  var defaultLists = {
    selectedMultipleValues: defaultValue || [],
    listForRender: defaultValue
  };

  var _useState7 = useState(defaultLists),
      _useState8 = _slicedToArray(_useState7, 2),
      lists = _useState8[0],
      setLists = _useState8[1]; // Usually used after creating new artist from the Modal. The artist to be passed should have the Dropdown format.


  var forceNewSelectedArtist = function forceNewSelectedArtist(artist) {
    // adding to the list of possibles
    setLists({
      selectedMultipleValues: [].concat(_toConsumableArray(lists.selectedMultipleValues), [artist]),
      listForRender: [].concat(_toConsumableArray(lists.listForRender), [artist])
    });
    setFieldValue(fieldName, [].concat(_toConsumableArray(lists.selectedMultipleValues), [artist]));
  }; // Add new artist modal
  // eslint-disable-next-line no-unused-vars


  var handleAddition = function handleAddition() {
    setNewArtistModalOpen(true);
  }; // Default OnChange function from the component


  var handleChange = function handleChange(event, data) {
    var latestAddition = data.value.slice(-1).pop();
    var latestAdditionJSON = lists.listForRender.find(function (item) {
      return item.value === latestAddition;
    });
    var isFound = lists.selectedMultipleValues.find(function (item) {
      return item.value === latestAddition;
    });

    var newLists = _objectSpread({}, lists);

    if (latestAdditionJSON && !isFound) {
      newLists.selectedMultipleValues = [].concat(_toConsumableArray(lists.selectedMultipleValues), [latestAdditionJSON]);
      setLists(newLists);
      setFieldValue(fieldName, newLists.selectedMultipleValues);
    } else {
      // Remove if not in the list
      lists.selectedMultipleValues.forEach(function (artist) {
        if (!data.value.includes(artist.value)) {
          newLists.selectedMultipleValues = _toConsumableArray(lists.selectedMultipleValues.filter(function (item) {
            return item.value !== artist.value;
          }));
          setLists(newLists);
          setFieldValue(fieldName, newLists.selectedMultipleValues);
        }
      });
    }
  };

  var setSearchTerm = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
      var artistAutocomplete, artistsList, selectItem, dropdownOptions, arrWithDuplicates, newLists;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              artistAutocomplete = new Autocomplete(context, 'catalog', 'Artist', 'en');
              _context2.prev = 2;
              _context2.next = 5;
              return artistAutocomplete.search(value);

            case 5:
              artistsList = _context2.sent;
              setIsLoading(false);

              if (ValidateAxiosResponse(artistsList)) {
                selectItem = {
                  key: 'entityId',
                  value: 'entityId',
                  text: 'title',
                  name: 'title'
                };
                dropdownOptions = buildSelectedWithConvertOptions(artistsList.data, selectItem);
                arrWithDuplicates = dropdownOptions && dropdownOptions.concat(lists.selectedMultipleValues);
                newLists = _objectSpread({}, lists);
                newLists.selectedMultipleValues = _toConsumableArray(lists.selectedMultipleValues);
                newLists.listForRender = _toConsumableArray(new _Set(arrWithDuplicates));
                setLists(newLists);
              }

              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              Logger(_context2.t0);
              setIsLoading(false);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 10]]);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [context, lists]); // Debouncing the custom location input

  useEffect(function () {
    if (debouncedSearchTerm && debouncedSearchTerm !== searchTerm.current) {
      setSearchTerm(debouncedSearchTerm);
      searchTerm.current = debouncedSearchTerm;
    }
  }, [debouncedSearchTerm, setSearchTerm]); // All the code part to be able to save from outside of the Artist form.

  var submitMyForm = null;

  var handleSubmitMyForm = function handleSubmitMyForm(e) {
    if (submitMyForm) {
      submitMyForm(e);
    }
  };

  var bindSubmitForm = function bindSubmitForm(submitForm) {
    submitMyForm = submitForm;
  };

  var handleArtistSelection = function handleArtistSelection(selectedList) {
    if (selectedList && selectedList.length > 0) {
      var selectedValues = selectedList.map(function (element) {
        return element.value;
      });
      handleChange(null, {
        value: selectedValues
      });
    } else {
      handleChange(null, {
        value: []
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  };

  return labels ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CMultiSelect, {
    options: lists.listForRender || [],
    placeholder: "",
    displayValue: "text",
    closeOnSelect: true,
    showArrow: true,
    loading: isLoading // eslint-disable-next-line no-unused-vars
    ,
    onSelect: function onSelect(selectedList, selectedItem) {
      handleArtistSelection(selectedList);
    } // eslint-disable-next-line no-unused-vars
    ,
    onRemove: function onRemove(selectedList, removedItem) {
      handleArtistSelection(selectedList);
    },
    onSearch: function onSearch(searchBy) {
      setUserInputValue(searchBy);
    },
    selectedValues: lists ? lists.selectedMultipleValues && lists.selectedMultipleValues.map(function (item) {
      return {
        key: item.key,
        value: item.value,
        text: item.text,
        name: item.value
      };
    }) : [],
    customArrow: /*#__PURE__*/React.createElement(Icon, {
      name: "caret-down",
      color: "#000",
      size: 20,
      style: {
        marginBottom: 20
      }
    })
  }), /*#__PURE__*/React.createElement(ModalStyled, {
    center: true,
    open: newArtistModalOpen
  }, /*#__PURE__*/React.createElement("h3", null, labels.labelsForm.translate('addArtistLabel')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormRules, {
    bindSubmitForm: bindSubmitForm,
    labels: labels,
    context: context,
    setNewArtistModalOpen: setNewArtistModalOpen,
    forceNewSelectedArtist: forceNewSelectedArtist,
    defaultFirstName: userInputValue
  })), /*#__PURE__*/React.createElement("div", {
    className: "pt-5"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: function onClick() {
      return setNewArtistModalOpen(false);
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    className: "ms-5",
    type: "submit",
    onClick: handleSubmitMyForm
  }, "Save")))) : null;
};

ArtistSelector.propTypes = {
  selected: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
  dropDownOptions: PropTypes.array,
  context: PropTypes.object,
  fieldName: PropTypes.string,
  defaultValue: PropTypes.array,
  labels: PropTypes.object
};
export default ArtistSelector;